import { Controller } from "react-hook-form"
import { HStack, Field, RadioGroup } from "@chakra-ui/react"

export default function RadioButtons({ control, rules, name, value, options, label, help }) {
    return (
        <Controller
            name={name}
            control={control}
            defaultValue={value || false}
            rules={rules}
            render={({ field, fieldState: { error } }) => {
                return (
                    <Field.Root invalid={!!error}>
                        <Field.Label>{label}</Field.Label>
                        <RadioGroup.Root onValueChange={e => field.onChange(e.value)} value={field.value}>
                            <HStack gap={10}>
                                {options.map(option => (
                                    <RadioGroup.Item key={option.value} value={option.value}>
                                        <RadioGroup.ItemHiddenInput />
                                        <RadioGroup.ItemIndicator />
                                        <RadioGroup.ItemText>{option.label}</RadioGroup.ItemText>
                                    </RadioGroup.Item>
                                ))}
                            </HStack>
                        </RadioGroup.Root>
                        {help && <Field.HelperText>{help}</Field.HelperText>}
                        {error && <Field.ErrorText>{error.message}</Field.ErrorText>}
                    </Field.Root>
                )
            }}
        />
    )
}
